module.exports = __webpack_public_path__ + "img/CS-Hybrid_Overview-Front_3.750c9ba7.jpg";